// extracted by mini-css-extract-plugin
export default {"summary-container":"DiscountSlabReportSummary_summary-container__Jyskf","summary-ctas":"DiscountSlabReportSummary_summary-ctas__7Ukvz"};